import { CLEAN_STRING_REGEX } from "@/config/constants";

export const normalizeTextToArray = (text) => {
  if (!text) return [];

  // Already an array
  if (Array.isArray(text)) return text;

  // If comma-separated string
  if (typeof text === "string" && text.includes(",")) {
    return text
      .split(",")
      .map((item) => item.replace(CLEAN_STRING_REGEX, "").trim())
      .filter(Boolean);
  }

  // Otherwise, split by bullets or newlines
  return text
    .split(/\n|•|-/)
    .map((item) => item.replace(CLEAN_STRING_REGEX, "").trim())
    .filter(Boolean);
};

export const formatNumber = (val) => {
    if (val == null || typeof val === "object") return "—";
    if (typeof val === "number") return new Intl.NumberFormat().format(val);
    return String(val);
};

// A count and its noun, agreeing. Both forms are spelled out by the caller
// because English plurals are not a rule: "3 databases" and "3 databases are".
//
//     plural(1, "database", "databases")  // "1 database"
//     plural(3, "update", "updates")      // "3 updates"
export const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

// A UUID's first hyphen-delimited segment — short enough to show inline next
// to a job title for disambiguation, without printing the full id.
export const shortId = (id) => (id == null ? "" : String(id).split("-")[0]);

// "Priya Uppal" → "PU". One letter when there is only one word, "?" when there's no name.
export const getInitials = (name = "") =>
  (name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "?";